import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function NotchRight({ idVariant = '', className }: Props) {
  return (
    <IconBase name="notch-right" w={38} className={className}>
      <path d="M38 18H37.2843C31.9799 18 26.8929 15.8929 23.1421 12.1421L16.8579 5.85786C13.1071 2.10713 8.02006 0 2.71573 0H0V38H38V18Z" fill="currentColor"/>
    </IconBase>
  )
}

export default NotchRight
